<template>
  <svg
    class="bz-icon"
    viewBox="0 -960 960 960"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    focusable="false"
  >
    <path :d="path" />
  </svg>
</template>

<script>
import { ICONS } from '../icons';

/**
 * An icon of the design system: a Material Symbol (src/ui/icons.js), drawn in the text's colour at
 * the text's size — `font-size` on it or on its parent sets it, like a glyph.
 *
 * @rule   Decorative by default (hidden from a screen reader): an icon next to its words says nothing
 *         more. An icon that stands alone and means something gets a `label`; an icon button gets its
 *         name on the button (BzButton's `ariaLabel`), not here.
 */
export default {
  name: 'BzIcon',
  props: {
    name: { type: String, required: true, validator: (n) => n in ICONS },
    label: { type: String, default: undefined },
  },
  computed: {
    path() {
      return ICONS[this.name];
    },
  },
};
</script>

<style scoped>
.bz-icon {
  display: inline-block;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
}
</style>
